import styled from 'styled-components'

import { CheckoutQA } from 'shared/dataAttributes'
import { colors, fonts } from 'shared/lib'
import { getShippingMethodText } from 'shared/utils/shipping-method-utils'
import { useCheckoutContext } from 'checkout/containers/CheckoutContextProvider'
import { formatMoneyObject } from 'shared/lib/formatMoneyObject'

export const ShippingMethodSummary = () => {
  const { order } = useCheckoutContext()

  const shippingServiceLevel = order?.shippingServiceLevelOptions?.find(
    (level) => level.id === order?.shippingServiceLevel,
  )

  if (!shippingServiceLevel) {
    return null
  }

  const { description, fullName, localizedPriceCents } = shippingServiceLevel

  return (
    <SummaryBox>
      <div>
        <MethodName data-qa={CheckoutQA.ShippingMethodSummaryPriceText}>{`${getShippingMethodText(
          fullName,
        )} - ${formatMoneyObject(localizedPriceCents, { showCents: true })}`}</MethodName>
        <MethodDescription>{description}</MethodDescription>
      </div>
    </SummaryBox>
  )
}

const SummaryBox = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  color: ${colors.FC2_BLACK};
  align-items: center;
`

const MethodName = styled.div`
  margin-bottom: 10px;
  font-weight: 500;
`

const MethodDescription = styled.label`
  ${fonts.BODY_TEXT}
`
